import type { ComponentProps, ReactNode } from 'react'
import { clsx } from 'clsx'

type FieldProps = {
  /** Id of the control inside; the validation message hangs off it. */
  fieldId: string
  error?: string
  reserveErrorSpace?: boolean
  className?: string
  children: ReactNode
}

export function Field({ fieldId, error, reserveErrorSpace = false, className, children }: FieldProps) {
  return (
    <div className={clsx('flex flex-col gap-1 md:gap-1.5', className)}>
      {children}
      {error || reserveErrorSpace ? (
        <p
          id={error ? errorId(fieldId) : undefined}
          className="min-h-[1lh] text-validation wrap-anywhere text-error-500"
        >
          {error}
        </p>
      ) : null}
    </div>
  )
}

export function errorId(fieldId: string) {
  return `${fieldId}-error`
}

export function isInvalid(value: ComponentProps<'input'>['aria-invalid']) {
  return value === true || value === 'true'
}

export function describedBy(fieldId: string, error: string | undefined, own?: string) {
  return [own, error ? errorId(fieldId) : undefined].filter(Boolean).join(' ') || undefined
}
